import React from 'react';
import cn from 'classnames';
import InfoCard from 'partial/components/InfoCard';
import {
  useTotalInteg,
  useTotalMasks,
  useTotalMsgs,
  useTotalOrgs,
} from '../hooks';

const loader = (
  <div className="bg-neutral-100 animate-pulse h-[110px] rounded-md" />
);

function Cards() {
  const [isMsgLoading, msgData] = useTotalMsgs();
  const [isOrgsLoading, orgsData] = useTotalOrgs();
  const [isIntegLoading, integData] = useTotalInteg();
  const [isMaskLoading, masksData] = useTotalMasks();
  return (
    <div className={cn('grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4')}>
      <InfoCard
        label="TOTAL MESSAGES"
        total={String(msgData?.total_messages || '0')}
        isLoading={isMsgLoading}
        loader={loader}
      />
      <InfoCard
        label="TOTAL AGENCY"
        total={String(orgsData?.total_organization || '0')}
        isLoading={isOrgsLoading}
        loader={loader}
      />
      <InfoCard
        label="TOTAL INTEGRATION"
        total={String(integData?.total_api_keys || '0')}
        isLoading={isIntegLoading}
        loader={loader}
      />
      <InfoCard
        label="MASK NAMES"
        total={String(masksData?.total_messages || '0')}
        isLoading={isMaskLoading}
        loader={loader}
      />
    </div>
  );
}

export default Cards;
